/* NZ Supps — scroll-reveal + image fade-in. Tiny, once-only, reduced-motion aware.
   Arms `.rv-armed` on <html> so all hidden states only exist when JS runs (no-JS = everything visible). */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    document.documentElement.classList.add('rv-armed');

    // --- Reliability net (Blake 2026-06-28): a missed per-container load listener leaves a lazy image
    // stuck at opacity:0 = intermittent "blank card". Mark EVERY lazy image visible the moment it loads,
    // globally (capture: img load doesn't bubble) + via sweeps. A stuck image becomes impossible.
    // Loading order is untouched (stays native / top-down).
    document.addEventListener('load', function (e) {
      var t = e.target;
      if (t && t.tagName === 'IMG' && t.getAttribute('loading') === 'lazy') t.classList.add('img-loaded');
    }, true);
    function nzsImgSweep() {
      document.querySelectorAll('img[loading="lazy"]').forEach(function (im) {
        if (im.complete && im.naturalWidth > 0) im.classList.add('img-loaded');
      });
    }
    nzsImgSweep();
    window.addEventListener('load', nzsImgSweep);
    setTimeout(nzsImgSweep, 1500);
    setTimeout(nzsImgSweep, 3500);

    // index stagger children
    document.querySelectorAll('[data-rv]').forEach(function (rv) {
      var kids = rv.querySelectorAll('[data-rv-child]');
      for (var i = 0; i < kids.length; i++) {
        kids[i].style.setProperty('--i', Math.min(i, 7)); // cap stagger at 7 steps
      }
      // lazy image fade-in
      rv.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        if (img.complete && img.naturalWidth > 0) { img.classList.add('img-loaded'); return; }
        img.addEventListener('load', function () { img.classList.add('img-loaded'); }, { once: true });
        img.addEventListener('error', function () { img.classList.add('img-loaded'); }, { once: true });
      });
    });

    // after the reveal finishes, strip the data attributes so elements fall back
    // to their OWN transitions (hover lifts, image zoom) with no stagger delay
    function reveal(rv) {
      rv.classList.add('rv-in');
      setTimeout(function () {
        rv.querySelectorAll('[data-rv-child]').forEach(function (k) { k.removeAttribute('data-rv-child'); k.style.removeProperty('--i'); });
        rv.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.classList.add('img-loaded'); });
        rv.removeAttribute('data-rv');
        rv.classList.remove('rv-in');
      }, 1100);
    }

    /* NZS-RVLOAD-0903 (Blake): the slide-up plays ONLY after real user input. Whatever the observer
       reports before that (initial paint, the PDP buy-box hoist, fonts/images settling near the fold)
       is shown instantly, so a page never animates as it arrives; the skeleton is the handoff. */
    var armed = false;
    ['wheel', 'touchstart', 'keydown', 'pointerdown'].forEach(function (ev) {
      window.addEventListener(ev, function () { armed = true; }, { once: true, passive: true, capture: true });
    });
    function show(rv) {
      rv.querySelectorAll('[data-rv-child]').forEach(function (k) { k.removeAttribute('data-rv-child'); k.style.removeProperty('--i'); });
      rv.removeAttribute('data-rv');
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          (armed ? reveal : show)(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    document.querySelectorAll('[data-rv]').forEach(function (rv) {
      // anything already in view on load reveals immediately (no scroll needed)
      var r = rv.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) {
        /* NZS-NOOPEN-0817 (Blake): above the fold on load = show INSTANTLY, no entrance transition
           (the fade/slide clashed with the card skeleton loaders). Strip the reveal state now so the
           base opacity:0/translateY never animates; below the fold still reveals on scroll (IO). */
        show(rv);
      } else {
        io.observe(rv);
      }
    });

    // hero stat count-up (once): elements marked data-countup with data-target
    document.querySelectorAll('[data-countup]').forEach(function (el) {
      var raw = el.getAttribute('data-countup');
      var m = raw.match(/^([^0-9]*)([0-9.,]+)(.*)$/);
      if (!m) return;
      var pre = m[1], post = m[3];
      var target = parseFloat(m[2].replace(/,/g, ''));
      var dec = (m[2].split('.')[1] || '').length;
      var hasComma = m[2].indexOf(',') >= 0;
      var t0 = null, DUR = 700;
      function fmt(v) {
        var s = v.toFixed(dec);
        if (hasComma) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return pre + s + post;
      }
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / DUR, 1);
        p = 1 - Math.pow(1 - p, 3); // ease-out cubic
        el.textContent = fmt(target * p);
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
